import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { crewService } from '@services/crew';
import { CREWS_BY_USER_QUERY_KEY } from './useCrews';
import { CREW_QUERY_KEY } from './useCrew';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

export type EditCrewArgs = {
  crewId: string;
  name: string;
};

export const useEditCrew = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['crew', 'edit'],
    mutationFn: async ({ crewId, name }: EditCrewArgs) => {
      if (!crewId) throw new Error('crewId is required');
      if (!name || !name.trim()) throw new Error('Name is required');
      return await crewService.updateCrew(crewId, name.trim());
    },
    onSuccess: (data) => {
      toast.success(tActionMessages.crewUpdatedSuccessfully);
      queryClient.invalidateQueries({ queryKey: CREWS_BY_USER_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: CREW_QUERY_KEY(data.crewId) });
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, tActionMessages.requestError));
    },
  });
};

export default useEditCrew;
